import { useApiQuery } from 'src/api';
import { useBuildVars } from 'src/config';

export interface ProgramListResult {
  vendorId: number;
  vendorName: string;
  vendorProgramCount: number;
  vendorProgramlist: ProgramData[];
}
export interface ProgramData {
  businessType: string;
  createdDate: string;
  lastModified: string;
  status: '0' | '1' | '2';
  uploadCount: string;
  vendorProgramDescription: string;
  vendorProgramId: number;
  vendorProgramName: string;
}
export interface ProgramListQuery {
  countryCode: string;
  vendorIdToSearch: number;
}
// get program list
export function useProgramListQuery(params: ProgramListQuery) {
  const buildVars = useBuildVars();
  return useApiQuery<ProgramListResult>(
    '/system.webapi.gds/api/v1/gdsCoreApiVendor/vendorProgram',
    params,
    {
      enabled:
        params.vendorIdToSearch !== 0 &&
        params.vendorIdToSearch !== null &&
        params.vendorIdToSearch !== undefined &&
        !Number.isNaN(params.vendorIdToSearch),
    },
    undefined,
    {
      host: buildVars.VP_API_BASE,
    }
  );
}
